import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PageType } from 'src/app/analytics/newrelic/enums/PageType';
import { NewrelicService } from 'src/app/analytics/newrelic/services/newrelic.service';
import { DataService } from 'src/app/data.service';
import { RouteStrategy } from 'src/app/shared/common/interfaces/common.interface';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';

@Component({
  selector: 'app-no-active-subscription',
  templateUrl: './no-active-subscription.component.html',
  styleUrls: ['./no-active-subscription.component.scss'],
})
export class NoActiveSubscriptionComponent implements OnDestroy {
  private isClicked: boolean = false;
  constructor(
    private dialogService: DialogService,
    private readonly dataService: DataService,
    private readonly navigationService: NavigationLibraryService,
    private readonly routerHistoryService: RouteHistoryService,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnDestroy(): void {
    this.dataService.disablePlayerListener = false;
  }

  ngAfterViewInit() {
    this.dataService.disablePlayerListener = true;
    this.navigationService.focusContainer('actions', true, 0, true);
  }

  subscribeNowAction() {
    if (this.isClicked) {
      return;
    }
    this.isClicked = true;
    const buttonText =
      this.data?.pageID === PageType.Player ||
      this.data?.pageID === PageType.Details
        ? 'go_back'
        : 'go_home';
    if (
      this.data?.routeStrategy === RouteStrategy.PopAndReplace ||
      this.data?.pageID === PageType.Player
    ) {
      setTimeout(() => {
        this.dialogService.close();
      }, 900);
      this.routerHistoryService.replaceHistory('plans', { buttonText });
    } else {
      setTimeout(() => {
        this.dialogService.close();
      }, 800);
      this.router.navigate(['plans'], {
        state: { buttonText },
      });
    }
  }

  maybeLaterAction() {
    if (this.isClicked) {
      return;
    }
    this.isClicked = true;
    if (this.data?.pageID === PageType.Player && this.data?.isFromDeeplink) {
      this.router.navigate([this.dataService.homeTab || '/']);
    }
    if (this.data?.routeStrategy === RouteStrategy.PopAndReplace) {
      this.routerHistoryService.goBack();
    }
    this.dialogService.close();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
